import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { Cotizador } from '../models/cotizador';
import { GeneralesProspecto } from '../models/generales-prospecto';
import { GeneralesProspectoService } from './generales-prospecto.service';
import { Prospecto } from '../models/prospecto';
import { ProspectoService } from './prospecto.service';
import { PlanService } from './plan.service';
import { Cobertura } from '../models/cobertura';
import { Planes } from '../models/planes';
import { ValoresGarantizaService } from './valores-garantizados.service';
import { ValoresGarantizados } from '../models/valoresGarantizados';
import { CotizacionService } from './cotizacion.service';


const BACKEND_URL = environment.apiUrl + '/cotizador/';

@Injectable({
    providedIn: 'root'
})
export class CotizadorService {

    constructor(private http: HttpClient, private router: Router,
        private generalesProspectoService: GeneralesProspectoService,
        private prospectoService: ProspectoService,
        private planService: PlanService,
        private valoresGarantizadosService: ValoresGarantizaService,
        private cotizacionService: CotizacionService) { }

    /**
     * Envia el ultimo valor al stream del observable.
     * @param prospecto a setear.
     */
    public setGeneralesProspecto2(prospecto: GeneralesProspecto): void {
        this.generalesProspectoService.setGeneralesProspecto(prospecto);
    }

    /**
     * Obtenemos el observable de los generales del prospecto.
     */
    public getGeneralesProspecto2(): Observable<GeneralesProspecto> {
        return this.generalesProspectoService.getGeneralesProspecto();
    }

    /**
    * Envia el ultimo valor al stream del observable.
    * @param prospecto a setear.
    */
    public setProspecto(prospecto: Prospecto): void {
        this.prospectoService.setProspecto(prospecto);
    }

    /**
     * Obtenemos el observable de los generales del prospecto.
     */
    public getProspecto(): Observable<Prospecto> {
        return this.prospectoService.getProspecto();
    }

    obtenerPlazos(plan: string): Observable<any> {
        return this.planService.obtenerPlazos(plan);
    }

    obtenerValoresMancomunados(edad: string, edadMancomunados: string): Observable<any> {
        return this.planService.obtenerValoresMancomunados(edad, edadMancomunados);
    }

    obtenerValorUdi(): Observable<any> {
        return this.planService.obtenerValorUdi();
    }

    obtenerDescuentos(): Observable<any> {
        return this.planService.obtenerDescuentos();
    }

    obtenerValorDolar(): Observable<any> {
        return this.planService.obtenerValorDolar();
    }

    obtenerTarifasCoberturas(cobertura: Cobertura): Observable<any> {
        return this.planService.obtenerTarifasCoberturas(cobertura);
    }

    obtenerTarifaCobertura(cobertura: Cobertura): Observable<any> {
        return this.planService.obtenerTarifaCobertura(cobertura);
    }

    obtenerValoresGarantizados(prospecto: Prospecto): Observable<any> {
        return this.valoresGarantizadosService.obtenerValoresGarantizados(prospecto);
    }

    /**
     * Envia el ultimo valor al stream del observable.
     * @param plan a setear.
     */
    public setPlanes(plan: Planes): void {
        this.planService.setPlanes(plan);
    }

    /**
     * Obtenemos el observable del plan.
     */
    public getPlanes(): Observable<Planes> {
        return this.planService.getPlanes();
    }

    public setValoresGarantizados(tablaValoresGarantizados: ValoresGarantizados[]): void {
        this.valoresGarantizadosService.setValoresGarantizados(tablaValoresGarantizados);
    }

    public getValoresGarantizados(): Observable<ValoresGarantizados[]> {
        return this.valoresGarantizadosService.getValoresGarantizados();
    }

    public GenerarPDF(prospecto: Prospecto, planes: Planes, valoresGarantizados: any, a1: number, a2: string, formato: string, edadRetiro: string): Observable<any> {
        return this.cotizacionService.GenerarPDF(prospecto, planes, valoresGarantizados, a1, a2, formato, edadRetiro);
    }

    public ObtenerComboLayout(): Observable<any> {
        return this.cotizacionService.obtenerComboLayout();
    }

}
